export default {
  name: 'marking--outActionType',
};